const TABLE_ALIAS_MARKER = '// table aliases';

export function appendTableAliases(source: string): string {
  const markerIndex = source.indexOf(`\n${TABLE_ALIAS_MARKER}`);
  const base = markerIndex === -1 ? source : source.slice(0, markerIndex);

  const exportRegex = /export const\s+([A-Za-z_$][\w$]*)\s*=\s*pgTable\s*\(/g;
  const tableExports = new Set<string>();

  for (const match of base.matchAll(exportRegex)) {
    const name = match[1];
    tableExports.add(name);
  }

  if (tableExports.size === 0) {

    return base;

  }

  const aliasLines = Array.from(tableExports)
    .sort()
    .map((name) => `export const ${name}Table = ${name};`)
    .join('\n');

  const prefix = base.trimEnd();
  return `${prefix}\n\n${TABLE_ALIAS_MARKER}\n${aliasLines}\n`;
}
